const rootKey = '/quarterly-revenue-status';

export const getQuarterlyRevenueAccount = () => {
  return `${rootKey}/fetchRevenue`;
};

export const createQuarterlyRevenueSummary = () => {
  return `${rootKey}/add-revenue-summary`;
};

export const editQuarterlyRevenueSummary = () => {
  return `${rootKey}/edit-revenue-summary`;
};

export const quarterlyRevenueById = (accountId: string) => {
  return `${rootKey}/${accountId}`;
};

export const exportQuarterlyRevenue = () => {
  return `${rootKey}/export`;
};
